import { Cell, Grid, Heading, HFlow, Icon, Text } from 'bold-ui'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { isNumberInRange } from 'util/number/number-in-range'
import { IDADE_FORA_DE_RASTREIO_TEXT } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA } from './model-saudeMulher'

interface UltimaConsultaSaudeSexualReprodutivaPanelProps {
  data: LocalDate
  idadeCidadao: number
}

export function UltimaConsultaSaudeSexualReprodutivaPanel(
  props: Readonly<UltimaConsultaSaudeSexualReprodutivaPanelProps>
) {
  const { data, idadeCidadao } = props

  const isInRange = isNumberInRange(idadeCidadao, RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA)

  return (
    <Grid gap={0} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='nurse' size={1} />
          <Heading level={4}>Última consulta de saúde sexual e reprodutiva</Heading>
        </HFlow>
        {isInRange ? <Text>{formatDate(data)}</Text> : <Text fontStyle='italic'>{IDADE_FORA_DE_RASTREIO_TEXT}</Text>}
      </Cell>
    </Grid>
  )
}
